<template>
  <div class="about">
    <h1>This is an about page</h1>
    <el-select
      v-model="postId"
      multiple
      style="margin-left: 20px;"
      placeholder="请选择"
      @change="specialChange"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.postName" :value="item.postId"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [
        {
          postId: "1",
          postName: "黄金糕"
        },
        {
          postId: "2",
          postName: "双皮奶"
        },
        {
          postId: "3",
          postName: "蚵仔煎"
        },
        {
          postId: "4",
          postName: "龙须面"
        },
        {
          postId: "5",
          postName: "北京烤鸭"
        }
      ],
      postId: ['2','5']
    };
  },
  methods: {
    specialChange(val) {
      console.log(val, 123);
      this.postId = val;
      console.log(this.postId,'this.postId');
    }
  }
};
</script>
